/**
 * Toolkit JavaScript
 * - This is the first entry point of all the subsequent Javascript.
 * - This is a good place to initialise any legacy/non-modular javascript files
 */
import twemoji from 'twemoji';
import truncate from '@/scripts/helpers/truncate-helper';

// jQuery plugins
// window.jQuery will be provided by Webpack
import 'dotdotdot';
import 'intl-tel-input';
import 'waypoints/lib/jquery.waypoints.js';
import 'jquery-sticky';

// Bootstrap plugins
import './vendors/bootstrap/tooltip';

/**
 * Global `fabricator` object
 * @namespace
 */
const toolkit = window.toolkit = {};

toolkit.initExternalSDK = function initExternalSDK() {
  window.fbAsyncInit = function fbAsyncInit() {
    // TODO: FB is undefined;
    FB.init({
      appId: 'your-app-id',
      xfbml: true,
      version: 'v2.6',
    });
  };

  // eslint-disable-next-line func-names
  (function(d, s, id) {
    const fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) { return; }
    const js = d.createElement(s); js.id = id;
    js.src = '//connect.facebook.net/en_US/sdk.js';
    fjs.parentNode.insertBefore(js, fjs);
  }(document, 'script', 'facebook-jssdk'));

  return this;
};

toolkit.initialNavBar = function initialNavBar() {
  $('#nav__watch, .nav__menu-btn, .nav__watch__dropdown__close-btn').click((e) => {
    e.preventDefault();
    $('.sticky-wrapper').attr('style', '');
    $('#nav__watch__dropdown').toggleClass('nav__watch__dropdown--expanded');

    // Prevent scrolling of the background when scrolling the dropdown
    $('body').toggleClass('prevent-scroll-on-body');
  });

  $('.nav__sign-in').click(() => {
    $('.modal--login').removeClass('hidden');
  });

  // var waypoint = new Waypoint({
  //  element: document.getElementById('nav-wrapper'),
  //  handler: function(direction) {
  //    console.log(direction);
  //     if (direction == "down") {
  //       $('body').addClass('nav-fixed');
  //     } else if (direction == "up") {
  //       $('body').removeClass('nav-fixed');
  //     }
  //   }
  // });

  $('#nav-wrapper').sticky();

  return this;
};

toolkit.initialDotdotdot = function initialDotdotdot() {
  setTimeout(() => {
    truncate.truncateMany(document.getElementsByClassName('text-wrap'));

    $('.text-wrap-see-more').dotdotdot({
      after: $('<a href="#" class="comment__item__content__see-more">See more</a>'),
    });

    $('.comment__item__content').on('click', '.comment__item__content__see-more', (e) => {
      e.preventDefault();
      const comment = $(e.currentTarget).parent();
      comment.trigger('destroy');
      comment.css('max-height', 'none');
    });
  }, 0); // send this task to the JavaScript's event queue so that it get processed later.

  return this;
};

toolkit.initTooltip = function initTooltip() {
  $(() => {
    $('[data-toggle="tooltip"]').tooltip();
  });

  return this;
};

toolkit.initialTwemoji = function initialTwemoji() {
  // FIXME: @cpwc: Initalize this in UI component?
  twemoji.parse(document.body, {
    callback(icon, options, variant) {
      switch (icon) {
        case 'a9': // © copyright
        case 'ae': // ® registered trademark
        case '2122': // ™ trademark
          return false;
        default:
          return ''.concat(options.base, options.size, '/', icon, options.ext);
      }
    },
  });
  return this;
};

/**
 * Initialization
 */
toolkit
  .initExternalSDK()
  .initialNavBar()
  .initialDotdotdot()
  .initTooltip()
  .initialTwemoji()
;
